import { render, staticRenderFns } from "./policyGrid.vue?vue&type=template&id=73e40158&"
import script from "./policyGrid.vue?vue&type=script&lang=js&"
export * from "./policyGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73e40158')) {
      api.createRecord('73e40158', component.options)
    } else {
      api.reload('73e40158', component.options)
    }
    module.hot.accept("./policyGrid.vue?vue&type=template&id=73e40158&", function () {
      api.rerender('73e40158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Insurance/components/policyGrid.vue"
export default component.exports